// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--2Kouc","link":"_93444fe79c--link--39cNw","link-area":"_93444fe79c--link-area--3CWic"};